import React from "react";
import { Box, Fade } from "@mui/material";
import christmasHat from "../../../assets/christmasHat.png";

const ChristmasHat = () => {
  return (
    <Fade in timeout={1500}>
      <Box
        sx={{
          position: "absolute",
          top: -93,
          right: -88,
          width: 190,
          height: 190,
          zIndex: 10,
          pointerEvents: "none",
          opacity: 0.95,
        }}
      >
        <img
          src={christmasHat}
          alt="Christmas Hat"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))",
          }}
        />
      </Box>
    </Fade>
  );
};

export default ChristmasHat;
